// extracted by mini-css-extract-plugin
export default {"loader":"zKqu-","ellipse":"XR-js","percentage":"E9uOO","skeleton-progress":"Ptgm8"};